import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../../shared/services/dialog.service';
import {
  FormBuilder,
  FormGroup,
  UntypedFormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { BreezeService } from '../../../shared/services/breeze.service';
import { HelperService } from '../../../shared/services/helper.service';
import {
  NgbActiveModal,
  NgbDate,
  NgbDatepickerModule,
} from '@ng-bootstrap/ng-bootstrap';
import { ErrorService } from '../../../shared/services/error.service';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
@Component({
    selector: 'app-signup-dialog',
    templateUrl: './signup-dialog.component.html',
    styleUrls: ['./signup-dialog.component.scss'],
    imports: [
    FormsModule,
    NgbDatepickerModule,
    ReactiveFormsModule
]
})
export class SignupDialogComponent implements OnInit {
  signUpForm: FormGroup = new FormGroup({});
  private emailRegEx =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  private passwordRegex = /^(?=.*[0-9])(?=.*[a-zA-Z])([ A-Za-z0-9_@./#&+-]+)$/;
  private numberRegex = /\d+/g;
  private phoneRegex = /^0[789][01]\d{8}$/;
  isLoading: boolean = false;
  errorMessage: unknown;

  titleArray: any[] = [
    {
      name: 'Mr',
      value: '1',
    },
    {
      name: 'Mrs',
      value: '2',
    },
    {
      name: 'Miss',
      value: '3',
    },
  ];

  constructor(
    private helperService: HelperService,
    private fb: FormBuilder,
    private breezeService: BreezeService,
    private errorService: ErrorService,
    private activeModal: NgbActiveModal,
    private dialogService: DialogService
  ) {}

  get name() {
    return this.signUpForm.get('name');
  }

  get gender() {
    return this.signUpForm.get('gender');
  }

  get title() {
    return this.signUpForm.get('titleType');
  }

  get family() {
    return this.signUpForm.get('family');
  }

  get email() {
    return this.signUpForm.get('email');
  }

  get password() {
    return this.signUpForm.get('password');
  }

  get confirmPassword() {
    return this.signUpForm.get('confirmPassword');
  }

  get phoneNumber() {
    return this.signUpForm.get('phoneNumber');
  }

  get birthDate() {
    return this.signUpForm.get('birthDate');
  }

  get dob() {
    return this.signUpForm.get('dob');
  }

  // get startDate() {
  //   return {
  //     year: new Date().getUTCFullYear() - 20,
  //     month: new Date().getUTCMonth(),
  //     day: 1,
  //   };
  // }

  get maxDate() {
    return { year: new Date().getUTCFullYear(), month: 12, day: 31 };
  }

  get minDate() {
    return { year: new Date().getUTCFullYear() - 100, month: 12, day: 31 };
  }

  ngOnInit(): void {
    this.breezeService.getIsLoadingListener().subscribe((isLoading) => {
      this.isLoading = isLoading;
    });
    this.errorService.getErrorListener().subscribe((errorMessage) => {
      this.errorMessage = errorMessage;
    });

    this.signUpForm = this.fb.group(
      {
        name: ['', [Validators.required]],
        family: ['', [Validators.required]],
        email: ['', [Validators.required, Validators.pattern(this.emailRegEx)]],
        socialSecurityNumber: [''],
        idType: [''],
        password: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(this.passwordRegex),
          ],
        ],
        confirmPassword: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(this.passwordRegex),
          ],
        ],

        phoneNumber: [
          '',
          [
            Validators.required,
            Validators.minLength(11),
            Validators.maxLength(11),
            Validators.pattern(this.phoneRegex),
          ],
        ],
        gender: ['1', [Validators.required]],
        titleType: ['1', [Validators.required]],
        birthDate: ['', [Validators.required]],
        dob: ['', [Validators.required]],
      },
      {
        validator: passwordMatch,
      }
    );

    this.title?.valueChanges.subscribe((value) => {
      switch (value) {
        case '1':
          this.gender?.patchValue('1');
          this.gender?.updateValueAndValidity();
          break;
        case '2':
        case '3':
          this.gender?.patchValue('2');
          this.gender?.updateValueAndValidity();
          break;

        default:
          break;
      }
    });
  }

  close() {
    this.activeModal.close();
  }

  onDateSelected(value: any) {
    this.birthDate?.patchValue(
      `${value?.year}${value?.month > 9 ? value?.month : `0${value?.month}`}${
        value?.day > 9 ? value.day : `0${value.day}`
      }`
    );
    this.birthDate?.updateValueAndValidity();
    this.dob?.patchValue(value);
    this.dob?.updateValueAndValidity();
  }

  onRegister() {
    // Handles login request
    if (this.signUpForm.invalid) {
      this.helperService.validateAllFormFields(this.signUpForm);
      return;
    } else {
      this.isLoading = true;
      this.breezeService.register(this.signUpForm.value);
    }
  }

  onLogin() {
    this.dialogService.openLoginDialog();
    this.dialogService.closeSignupModal();
  }

  containAlphaNumeric(): boolean {
    const passwordValue = this.password?.value;
    let hasAlphabetic = false;
    let hasNumeric = false;

    for (const char of passwordValue) {
      if (!isNaN(Number(char)) && /^[0-9]+$/.test(char)) {
        hasNumeric = true;
      } else if (/^[a-zA-Z]+$/.test(char)) {
        hasAlphabetic = true;
      }

      if (hasAlphabetic && hasNumeric) {
        return true;
      }
    }

    return false;
  }
}

function passwordMatch(
  formGroup: UntypedFormGroup
): ValidationErrors | undefined | null {
  const passwordControl = formGroup.get('password');
  const confirmPasswordControl = formGroup.get('confirmPassword');

  if (passwordControl?.value === confirmPasswordControl?.value) {
    return null;
  } else {
    return {
      passwordMatch: true,
    };
  }
}
